import { createFileRoute } from '@tanstack/react-router'
import { EnrichmentPage } from '../../../../modules/enrichment/enrichment-page'
import { SettingsShell } from '../../../../modules/settings/settings-shell'

/**
 * The enrichment settings surface (PLAN-05): source-data health, rollup freshness,
 * the ZoomInfo credit pre-flight, and the AI data-cleanup review queue. Wrapped in
 * PLAN-10's SettingsShell for the consistent two-pane settings layout.
 */
export const Route = createFileRoute('/_authed/settings/enrichment/')({
  component: () => (
    <SettingsShell>
      <EnrichmentPage />
    </SettingsShell>
  ),
})
